import { render, staticRenderFns } from "./NewMainView.vue?vue&type=template&id=3a119e62"
import script from "./NewMainView.vue?vue&type=script&lang=js"
export * from "./NewMainView.vue?vue&type=script&lang=js"
import style0 from "./NewMainView.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports